export const aboutObjOne = {
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "About the App",
  headline: "Why you need Date Ideas.",
  description:
    "You need excitement in your life, especially if you have found the one. Life is all about is all about creating cute memories, atleast I think. I like the idea of bringing people closer together, however this app is for inspiration purposes only. I do not take responsibility for any bad dates.",
  buttonLabel: "",
  imgStart: "start",
  img: "./images/terry-loves-love.gif",
  alt: "image goes here.",
  hasLink: false,
  link: "",
  isPurple: false,
};
